import { Navigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, FileText, LogOut } from "lucide-react";

export default function AdminLayout({ children }) {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) return <div className="p-10 font-mono">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const nav = [
    { to: "/admin", label: "Inquiries", icon: <LayoutDashboard size={16} /> },
    { to: "/admin/content", label: "Content", icon: <FileText size={16} /> },
  ];

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex flex-col md:flex-row">
      {/* SIDEBAR */}
      <aside className="md:w-64 border-b-2 md:border-b-0 md:border-r-2 border-[#091526] bg-white flex-shrink-0">
        <div className="p-6 border-b-2 border-[#091526]">
          <Link to="/" className="flex items-center gap-3">
            <img src="/images/logo.png" alt="logo" className="h-10 w-10 border-2 border-[#091526] bg-white object-contain" />
            <div>
              <div className="font-display text-lg leading-none">ADMIN</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#091526]/60 mt-1">Pile Glide Pro</div>
            </div>
          </Link>
        </div>

        <nav className="p-4 space-y-1">
          {nav.map((n) => {
            const active = location.pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] font-bold border-2 ${
                  active ? "border-[#091526] bg-[#1E5BB8]" : "border-transparent hover:bg-[#F4F4F5]"
                }`}
              >
                {n.icon} {n.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 mt-auto border-t-2 border-[#091526] md:absolute md:bottom-0 md:w-64">
          <div className="px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#091526]/60 truncate">
            {user.email}
          </div>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="w-full flex items-center justify-center gap-2 px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] font-bold border-2 border-[#091526] hover:bg-[#091526] hover:text-[#F4F4F5] transition-colors"
          >
            <LogOut size={14} /> Logout
          </button>
        </div>
      </aside>

      {/* MAIN */}
      <main className="flex-1 p-6 md:p-10 max-w-full overflow-x-auto">{children}</main>
    </div>
  );
}
